import script from "./report2Zyml.vue?vue&type=script&setup=true&lang=js"
export * from "./report2Zyml.vue?vue&type=script&setup=true&lang=js"

import "./report2Zyml.vue?vue&type=style&index=0&id=72e0c6bc&lang=less"

const __exports__ = script;

export default __exports__